import Gun from 'gun';
import 'gun/sea';
import { GUN_RELAY } from './app.config';

const gun = Gun({
  peers: [GUN_RELAY],
  // Disable localStorage — stale local data competes with and can override
  // fresh relay data causing sync inconsistencies between users. All
  // persistence goes through the relay's radisk (server-side storage).
  localStorage: false,
  // Retry WebSocket connection every 4 seconds on drop
  retry: 4000,
  // Disable multicast (not useful in production, can cause noise)
  multicast: false,
  // Disable AXE peer-to-peer mesh — we use a single relay topology
  axe: false,
});

// @ts-ignore — SEA is attached to Gun globally after import
export const SEA = Gun.SEA;

export default gun;
